import { apolloClient } from '@/store/graphql.config'
import { customerDeliveryExceptionsQuery } from '@/store/modules/deliveryDates/queries/customerDeliveryExceptions'
import { CalendarExceptions } from '@/store/modules/deliveryDates/interfaces/calendarException'

type MagentoExceptionItem = {
  shipTo: string;
  shipToId: string;
  hasExceptions: boolean;
  popupSeen: boolean;
  deliveryExceptions: CalendarExceptions['deliveryExceptions'];
}

type CustomerDeliveryExceptionsResponse = {
  customerDeliveryExceptions: MagentoExceptionItem[];
}

export async function fetchExceptionsFromMagento (shipToIds: string[]): Promise<CalendarExceptions[]> {
  const { data } = await apolloClient.query<CustomerDeliveryExceptionsResponse>({
    query: customerDeliveryExceptionsQuery,
    variables: { shipToIds }
  })

  const result = data?.customerDeliveryExceptions
  if (!result || result.length === 0) return []

  return result.map(({ shipTo, shipToId, popupSeen, deliveryExceptions }) => ({
    shipTo,
    shipToId,
    popupSeen,
    deliveryExceptions
  }))
}
